/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button-wrapper[_ngcontent-%COMP%]{margin-top:30px}.or-delimiter[_ngcontent-%COMP%]{margin:20px 0;font-style:italic;color:#b7b7b7}.custom-value[_ngcontent-%COMP%]{margin:0 auto;width:180px}.custom-value[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{margin:15px auto 0}"];
export { styles as styles };
